// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .container {
  width: 350px;
}
:host .container .label {
  display: inline-block;
}
:host .container .label-show {
  width: 45px;
  text-align: center;
}
:host .container .label-enable {
  width: 70px;
}`, "",{"version":3,"sources":["webpack://./src/app/gauges/gauge-property/permission-dialog/permission-dialog.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/gauges/gauge-property/permission-dialog/permission-dialog.component.scss"],"names":[],"mappings":"AACI;EACI,YAAA;ACAR;ADEQ;EACI,qBAAA;ACAZ;ADGQ;EACI,WAAA;EACA,kBAAA;ACDZ;ADIQ;EACI,WAAA;ACFZ","sourcesContent":[":host {\n    .container {\n        width: 350px;\n\n        .label {\n            display: inline-block;\n        }\n\n        .label-show {\n            width: 45px;\n            text-align: center;\n        }\n\n        .label-enable {\n            width: 70px;\n        }\n    }\n}",":host .container {\n  width: 350px;\n}\n:host .container .label {\n  display: inline-block;\n}\n:host .container .label-show {\n  width: 45px;\n  text-align: center;\n}\n:host .container .label-enable {\n  width: 70px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
